// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState } from 'react'
import { IMG_TOP_BUFFER, DARKER_SAVANT_GREEN } from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

function ShareButton({
    isEmpty,
    onDownload,
}: {
    isEmpty: boolean
    onDownload: () => void
}) {
    const { SETTINGS_MENU_DIM } = useDimensions()
    const [hovered, setHovered] = useState(false)

    return (
        <g
            id="comp-tool-share-button"
            // Shifted Y instead of X:
            transform={`translate(${IMG_TOP_BUFFER}, ${
                IMG_TOP_BUFFER + SETTINGS_MENU_DIM + 5
            })`}
            style={{ cursor: 'pointer', opacity: 0.5 }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => {
                if (!isEmpty) {
                    onDownload()
                }
            }}
        >
            <rect
                x={0}
                y={0}
                width={SETTINGS_MENU_DIM}
                height={SETTINGS_MENU_DIM}
                rx={2}
                fill={hovered ? DARKER_SAVANT_GREEN : '#ffffff'}
                stroke={DARKER_SAVANT_GREEN}
                strokeWidth={1}
                style={{ transition: 'fill 0.2s ease-in-out' }}
            />
            <svg
                x={0}
                y={0}
                width={SETTINGS_MENU_DIM}
                height={SETTINGS_MENU_DIM}
                viewBox="-4 -4 32 32"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M12 15V3m0 0L8 7m4-4l4 4"
                    stroke={hovered ? '#ffffff' : DARKER_SAVANT_GREEN}
                    fill="none"
                    style={{ transition: 'stroke 0.2s ease-in-out' }}
                />
            </svg>
        </g>
    )
}

export default ShareButton
